import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useCategoryAutomationSettings() {
  const {
    tours: {
      ShippingAutomationSettings: { Category },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Category.Title,
      steps: [
        {
          content: Category.Step1.Text,
          placement: 'auto',
          target: '#categoryAutomation',
          title: Category.Step1.Title,
          disableBeacon: true,
          link: Category.Step1.DetailsLink,
        },
        {
          content: Category.Step2.Text,
          placement: 'auto',
          target: '#categoryForm',
          title: Category.Step2.Title,
          disableBeacon: true,
          link: Category.Step2.DetailsLink,
          styles: {
            spotlight: {
              maxWidth: '930px',
            },
          },
        },
        {
          content: Category.Step3.Text,
          placement: 'auto',
          target: '#quantity',
          title: Category.Step3.Title,
          disableBeacon: true,
          link: Category.Step3.DetailsLink,
          styles: {
            spotlight: {
              marginTop: '-25px',
              minHeight: '60px',
            },
          },
        },
        {
          content: Category.Step4.Text,
          placement: 'auto',
          target: '#shippingMethod',
          title: Category.Step4.Title,
          disableBeacon: true,
          link: Category.Step4.DetailsLink,
          styles: {
            spotlight: {
              marginTop: '-25px',
              minHeight: '60px',
            },
          },
        },
        {
          content: Category.Step5.Text,
          placement: 'auto',
          target: '#productId',
          title: Category.Step5.Title,
          disableBeacon: true,
          link: Category.Step5.DetailsLink,
          styles: {
            spotlight: {
              marginTop: '-25px',
              minHeight: '60px',
            },
          },
        },
        {
          content: Category.Step6.Text,
          placement: 'auto',
          target: '#countryZoneRecepient',
          title: Category.Step6.Title,
          disableBeacon: true,
          link: Category.Step6.DetailsLink,
          styles: {
            spotlight: {
              marginTop: '-25px',
              minHeight: '60px',
            },
          },
        },
        {
          content: Category.Step7.Text,
          placement: 'auto',
          target: '#addCategoryPackagingForm',
          title: Category.Step7.Title,
          disableBeacon: true,
          link: Category.Step7.DetailsLink,
        },
        {
          content: Category.Step8.Text,
          placement: 'auto',
          target: '#addCategoryAutomationRule',
          title: Category.Step8.Title,
          disableBeacon: true,
          link: Category.Step8.DetailsLink,
        },
      ],
    }),
    [Category],
  );

  return [pageTour];
}
